





































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { getElement } from "@/lib/elementHelpers";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import CustomScroll from "@/components/CustomScroll";
import OptionAddCover from "./components/OptionAddCover";
import OptionPreview from "./components/OptionPreview";
import OptionPrice from "./components/OptionPrice";
import OptionSchedulePost from "./components/OptionSchedulePost";

@Component({
  name: "EditPostOptions",
  components: { OptionAddCover, OptionPreview, OptionPrice, OptionSchedulePost, BaseButton, BaseIcon, CustomScroll },
})
export default class EditPostOptions extends Vue {
  @Prop({ required: true })
  public readonly postData!: ContentSet;

  @Prop({ type: Boolean, default: false })
  public readonly disableSubmitButton!: boolean;

  public hasChevrons = true;

  public emptyOptions = false;

  public showOptions = false;

  public saving: boolean = false;

  public disableButton: boolean = true;

  public get openOptions(): boolean {
    return !this.emptyOptions && this.showOptions;
  }

  public get hideTeaserOption(): boolean {
    return this.postData.type === ContentFeedTypeEnum.CLIP;
  }

  public get published() {
    return this.postData.published;
  }

  public onShowClick() {
    this.showOptions = !this.showOptions;
  }

  public get showIcon() {
    return this.showOptions ? "sci-arrow-down" : "sci-gear";
  }

  public setButtonClickable(isDisabled: boolean) {
    this.disableButton = isDisabled;
  }

  public onPublish() {
    if (this.disableButton) return;
    this.saving = true;
    this.$emit("publish", () => {
      this.saving = false;
    });
  }

  public mounted() {
    emitter.on<any>(EVENTS.SET_TAGGED_USERS, this.setButtonClickable);
    const onUpdated = () => {
      this.hasChevrons = getElement(this.$refs["chevrons"]).childElementCount !== 0;
      this.emptyOptions = !this.hasChevrons && getElement(this.$refs["menu"]).childElementCount === 1;
    };
    const observer = new MutationObserver(onUpdated);
    observer.observe(getElement(this.$refs["menu"]), { childList: true });
    observer.observe(getElement(this.$refs["chevrons"]), { childList: true });
    onUpdated();
    this.$once("hook:beforeDestroy", () => {
      emitter.off<any>(EVENTS.SET_TAGGED_USERS, this.setButtonClickable);
      observer.disconnect();
    });
  }
}
